import React from 'react'
import {RouteComponentProps} from '@reach/router'

export const RouteGroup: React.FunctionComponent<RouteComponentProps> = ({children}) => {
  return <>{children}</>
}